module.exports = __webpack_public_path__ + "media/images/mailers/email_logo-b466dac5467f20684203d5e251b27623.png";